import axis from '../../assets/flooring/axis.webp'
import vector from '../../assets/flooring/vector.webp'
import sprint from '../../assets/flooring/sprint.webp'
import grid from '../../assets/flooring/grid.webp'
import coverCourt from '../../assets/flooring/cover-court.webp'
import colourCourt from '../../assets/flooring/colour-court.webp'

export type FloorSystem = {
    slug: string
    // Position in the range, shown above the name on the cards.
    tag: string
    name: string
    description: string
    image: string
}

// Shared by the home page's Division 02 block and the /sports-flooring listing,
// so the two never drift apart.
export const FLOOR_SYSTEMS: FloorSystem[] = [
    {
        slug: 'axis',
        tag: 'System 01',
        name: 'Axis',
        description: 'Solo-sleeper floating system. LVL sleepers on rubber pads under a plywood bearing panel. Cost-effective specification for training facilities.',
        image: axis,
    },
    {
        slug: 'vector',
        tag: 'System 02',
        name: 'Vector',
        description: 'Dual-sleeper floating system. A second LVL sleeper layer balances ball bounce against athlete comfort for competition courts.',
        image: vector,
    },
    {
        slug: 'sprint',
        tag: 'System 03',
        name: 'Sprint',
        description: 'Portable system on a double-layer solid-wood keel. Interlocking panels that set up and strike quickly for events.',
        image: sprint,
    },
    {
        slug: 'grid',
        tag: 'System 04',
        name: 'Grid',
        description: 'Anchored floating system. Factory-made modules interlock with steel tongues into HDPE sockets, fastened to the ground for a fixed suspended structure.',
        image: grid,
    },
]

export const FLOORING_PATH = '/sports-flooring'

export { coverCourt, colourCourt }
